import * as Yup from "yup";

export const WELFARE_TYPE = {
  EXTERNAL_REIMBURSEMENT: "External Reimbursement",
  EXTRA_ALLOWANCE: "Extra Allowance",
  OTHER: "Other",
  GENERAL: "General",
  PAYROLL_REIMBURSEMENT: "Payroll Reimbursement",
};

export const WELFARE_LIMIT_TYPE = {
  BASED_ON_SALARY: "Based on salary",
  CUSTOM: "Custom",
};

export const WELFARE_CALCULATE_TYPE = {
  INCOME: "Income",
  DEDUCTION: "Deduction",
};

export const wefareLimitDefault = {
  positionId: null,
  limitTime: null,
  limitPerYear: null,
  maximumSalaryBaseLimit: null,
  usableAmount: null,
  numberOfRights: null,
};

export const initialValues = {
  welfareTypeId: null,
  welfareType: null,
  welfareName: null,
  welfareNameEn: null,
  description: null,
  calculateAs: WELFARE_CALCULATE_TYPE.INCOME,
  haveReceiver: "N",
  welfareLimitList: [wefareLimitDefault],
};

const WelfareSchema = Yup.object().shape({
  welfareTypeId: Yup.string().required("Please select."),
  welfareName: Yup.string().required("Please enter."),
  welfareNameEn: Yup.string().required("Please enter."),
  incomeId: Yup.string().when("welfareType", {
    is: (val) => val === WELFARE_TYPE.EXTRA_ALLOWANCE,
    then: () => Yup.string().required("Please select."),
    otherwise: () => Yup.string().notRequired(),
  }),
  limitTypeId: Yup.string().when("setWelfareLimit", {
    is: (val) => val,
    then: () => Yup.string().required("Please select."),
    otherwise: () => Yup.string().notRequired(),
  }),
});

export default WelfareSchema;
